// privatokonomi-messages-part3 translations (English catalog).
window.PlummeI18n.register('en', {
  'pkn.tw.step.situation': 'Your situation',
  'pkn.tw.step.income': 'Income',
  'pkn.tw.step.workTravel': 'Work and travel',
  'pkn.tw.step.housingDebt': 'Housing and debt',
  'pkn.tw.step.family': 'Family',
  'pkn.tw.step.savingsInvesting': 'Savings and investments',
  'pkn.tw.step.otherMatters': 'Other circumstances',
  'pkn.tw.step.business': 'Business',
  'pkn.tw.step.deductions': 'Deductions',
  'pkn.tw.step.summary': 'Summary',
  'pkn.acc.fillName': 'Enter an account name',
  'pkn.acc.editAccount': 'Edit account',
  'pkn.acc.addAccount': 'Add account',
  'pkn.acc.fieldName': 'Account name',
  'pkn.acc.phName': 'E.g. DNB current account',
  'pkn.acc.fieldNumber': 'Account number',
  'pkn.acc.phNumber': 'E.g. 1234.56.78901',
  'pkn.acc.openingBalance': 'Opening balance (kr)',
  'pkn.acc.closingBalance': 'Closing balance (kr)',
  'pkn.acc.numberHint': 'An account number makes it easier to match future account statements to the right account. Use a minus sign for credit debt, e.g. −12400.',
  'pkn.acc.account': 'Account',
  'pkn.acc.accountLower': 'account',
  'pkn.acc.theAccount': 'the account',
  'pkn.acc.theStatement': 'the account statement',
  'pkn.acc.noNumber': 'No account number',
  'pkn.acc.noBalance': 'No balance',
  'pkn.acc.transactionsCount': '{count} transactions',
  'pkn.acc.statementOne': '{count} account statement',
  'pkn.acc.statementMany': '{count} account statements',
  'pkn.acc.kpi.read': 'Transactions read',
  'pkn.acc.kpi.statements': 'Statements',
  'pkn.acc.kpi.categories': 'Categories',
  'pkn.acc.kpi.unprocessed': 'Unprocessed',
  'pkn.acc.statementsFor': 'Account statements for {year} imported to {name}',
  'pkn.acc.noStatementsForYear': 'No account statements for {year} are linked to this account. Choose another year or upload a file under "Import financial data".',
  'pkn.acc.statement': 'Account statement',
  'pkn.acc.uploaded': 'Uploaded',
  'pkn.acc.readIn': 'Read in',
  'pkn.acc.failed': 'Failed',
  'pkn.acc.reading': 'Reading in …',
  'pkn.acc.deleteTitle': 'Delete {name}?',
  'pkn.acc.deleteAccount': 'Delete account',
  'pkn.acc.deleteWith': 'The account is deleted together with',
  'pkn.acc.and': 'and',
  'pkn.acc.linkedCannotUndo': 'linked to it. This cannot be undone.',
  'pkn.acc.deletePermanent': 'The account is deleted permanently. This cannot be undone.',
  'pkn.acc.deleting': 'Deleting',
  'pkn.acc.deletingSuffix': 'and all the transactions that were read from it. This cannot be undone.',
  'pkn.acc.noAccounts': 'No accounts have been registered yet. Press "Add account" to register a current account, savings account or credit card — or choose an account name when you upload an account statement.',
  'pkn.acc.noAccountsOfType': 'No accounts of this type.',
  'pkn.acc.cardStatementOne': '{count} statement',
  'pkn.acc.cardStatementMany': '{count} statements',
  'pkn.imp.beingRead': 'Being read …',
  'pkn.imp.pickAccountFor': 'Choose which account the statement belongs to.',
  'pkn.imp.numberHint': 'An account number makes it easier to match future account statements and bank integration to the right account.',
  'pkn.imp.accounts': 'Accounts',
  'pkn.imp.statements': 'Account statements',
  'pkn.imp.sayA': 'Upload an account statement, and',
  'pkn.imp.sayB': 'will read each transaction, link it to the right account and categorise it automatically. You do not need to do anything manually — I keep your finances up to date in the background.',
  'pkn.imp.recategorising': 'Categorising …',
  'pkn.imp.recategorise': 'Categorise again',
  'pkn.imp.uploadingDots': 'Uploading …',
  'pkn.imp.dropHere': 'Drag and drop files here',
  'pkn.imp.dropSub': 'Account statements, credit card statements and CSV export. You choose the account in the next step. XLSX and CSV are read directly, PDF is read on a best-effort basis from text.',
  'pkn.imp.uploading': 'Uploading',
  'pkn.imp.chooseFiles': 'Choose files',
  'pkn.imp.fetching': 'Fetching import status …',
  'pkn.imp.unlinkedNote': 'These account statements have no account. Link them to an account to bring them into the overview.',
  'pkn.imp.upload': 'Upload',
  'pkn.kat.sort.date-desc': 'Newest first',
  'pkn.kat.sort.date-asc': 'Oldest first',
  'pkn.kat.sort.amt-desc': 'Highest amount',
  'pkn.kat.sort.amt-asc': 'Lowest amount',
  'pkn.kat.tips.housing.1': 'Switch electricity contract — spot price can be cheaper than a fixed price',
  'pkn.kat.tips.housing.2': 'Review TV and broadband subscriptions you do not fully use',
  'pkn.kat.tips.housing.3': 'Check whether the mortgage interest rate can be negotiated down',
  'pkn.kat.tips.food.1': 'Shop with a weekly list — impulse purchases account for a large share',
  'pkn.kat.tips.food.2': 'Switch to the chains\' own brands for what you buy often',
  'pkn.kat.tips.food.3': 'Do big shops less often for less waste and fewer impulse purchases',
  'pkn.kat.tips.shopping.1': 'Put items in the basket and wait 48 hours before you buy',
  'pkn.kat.tips.shopping.2': 'Set a fixed monthly shopping budget',
  'pkn.kat.tips.shopping.3': 'Unsubscribe from newsletters and app notifications that tempt you to buy',
  'pkn.kat.tips.transport.1': 'Consider a monthly pass instead of single tickets',
  'pkn.kat.tips.transport.2': 'Cycle or walk short trips you drive today',
  'pkn.kat.tips.transport.3': 'Fill up at the cheapest chain in your area',
  'pkn.kat.tips.dining.1': 'Set a weekly limit for eating and drinking out',
  'pkn.kat.tips.dining.2': 'Swap two takeaway evenings a week for home-cooked food',
  'pkn.kat.tips.dining.3': 'Order pick-up instead of delivery — you save fees and tips',
  'pkn.kat.tips.travel.1': 'Book flights 6–8 weeks before departure for a lower price',
  'pkn.kat.tips.travel.2': 'Travel outside school holidays when possible',
  'pkn.kat.tips.travel.3': 'Use bonus points you have already collected',
  'pkn.kat.tips.insurance.1': 'Gather your insurance with one provider for a bundle discount',
  'pkn.kat.tips.insurance.2': 'Check that the cover actually matches your needs',
  'pkn.kat.tips.insurance.3': 'Increase the excess slightly for a lower monthly premium',
  'pkn.kat.tips.subscriptions.1': 'Cancel services you have not used in the last 30 days',
  'pkn.kat.tips.subscriptions.2': 'Share a family streaming subscription instead of having your own',
  'pkn.kat.tips.subscriptions.3': 'Switch to annual payment where it is cheaper than monthly',
  'pkn.kat.tips.default.1': 'Set a monthly cap for the category',
  'pkn.kat.tips.default.2': 'Review fixed charges you can adjust or cancel',
  'pkn.kat.tips.default.3': 'Move what you save straight to a savings goal',
  'pkn.kat.importedStatement': 'Imported account statement',
  'pkn.kat.unknown': 'Unknown',
  'pkn.kat.leadEmpty': 'There are no imported transactions in {category} for this period yet.',
  'pkn.kat.leadOne': '{category} amounts to {total} spread over {count} transaction, with an average of {average} per purchase.',
  'pkn.kat.leadMany': '{category} amounts to {total} spread over {count} transactions, with an average of {average} per purchase.',
  'pkn.kat.topItem': 'The largest single item is {name}, where you have spent {amount}.',
  'pkn.kat.changeUp': 'The category increased {pct} % compared with last month.',
  'pkn.kat.changeDown': 'The category fell {pct} % compared with last month.',
  'pkn.kat.lineOne': '{count} line',
  'pkn.kat.lineMany': '{count} lines',
  'pkn.kat.moving': 'Moving …',
  'pkn.kat.move': 'Move',
  'pkn.kat.vsPrev': 'vs. previous mo.',
  'pkn.kat.timesAverage': '{factor}× the average',
  'pkn.kat.howToCut': 'How you can cut back',
  'pkn.kat.potential': 'Potential ~{amount}/mo',
  'pkn.kat.clearAll': 'Clear all',
  'pkn.kat.selectAll': 'Select all',
  'pkn.kat.learn': 'Learn from this choice for future imports',
  'pkn.kat.noTxInCategory': 'No transactions in this category.',
  'pkn.kat.noTxMatchSearch': 'No transactions match the search.',
  'pkn.sce.notCalculable': 'Not calculable',
  'pkn.sce.base.label': 'Today\'s plan',
  'pkn.sce.base.story': 'With today\'s plan — {save} in savings and {debt} in extra debt repayment every month — this is the course your finances are on. All the scenarios below are calculated from this starting point.',
  'pkn.sce.saving.label': 'Increase savings',
  'pkn.sce.saving.field': 'Extra savings per month',
  'pkn.sce.saving.statExtra': 'Extra savings',
  'pkn.sce.saving.stat5y': 'Over 5 years',
  'pkn.sce.saving.story': 'If you set aside {amount} extra per month, your wealth grows noticeably faster. Goals are reached several months earlier on average.',
  'pkn.sce.home.label': 'Buy a home',
  'pkn.sce.home.price': 'Home price',
  'pkn.sce.equity': 'Equity',
  'pkn.sce.rate': 'Interest',
  'pkn.sce.term': 'Loan term',
  'pkn.sce.loanType': 'Loan type',
  'pkn.sce.annuity': 'Annuity',
  'pkn.sce.serial': 'Serial',
  'pkn.sce.loan': 'Loan',
  'pkn.sce.instalment': 'Instalment',
  'pkn.sce.home.firstInterest': 'Initial interest',
  'pkn.sce.home.value': 'Home value',
  'pkn.sce.home.storySerial': 'A home at {price} with {equity} in equity gives a loan of {loan} and a serial loan with an instalment of around {monthly} per month. The equity is tied up, but the home builds wealth over time.',
  'pkn.sce.home.storyAnnuity': 'A home at {price} with {equity} in equity gives a loan of {loan} and an annuity loan with an instalment of around {monthly} per month. The equity is tied up, but the home builds wealth over time.',
  'pkn.sce.car.label': 'Buy a car',
  'pkn.sce.car.price': 'Car price',
  'pkn.sce.car.depreciation': 'Depreciation 5 years',
  'pkn.sce.car.story': 'A car at {price} with {equity} in equity gives a loan of {loan} and an instalment of around {monthly} per month. A car loses value, so net wealth is pulled down in the first years.',
  'pkn.sce.retire.label': 'Retire earlier',
  'pkn.sce.retire.field': 'Desired retirement age',
  'pkn.sce.retire.statAge': 'Desired age',
  'pkn.sce.retire.statEarlier': 'Years earlier',
  'pkn.sce.retire.statNeeded': 'Extra needed',
  'pkn.sce.retire.storyNone': 'With a retirement age of {age} you follow today\'s plan — no extra saving is required.',
  'pkn.sce.retire.story': 'If you want to retire at {age} — {years} years earlier than today\'s plan — you need to cover around {gap} in extra retirement needs. That corresponds to roughly {required} of extra saving per month from now.',
  'pkn.sce.debt.label': 'Pay off debt',
  'pkn.sce.debt.today': 'Debt today',
  'pkn.sce.debt.extraField': 'Extra repayment per month',
  'pkn.sce.debt.statExtra': 'Extra repayment',
  'pkn.sce.debt.statEarlier': 'Debt-free earlier',
  'pkn.sce.yearsDecimal': '{years} yrs',
  'pkn.sce.debt.statInterest': 'Interest saved',
  'pkn.sce.debt.storyNone': 'Enter your debt to see how much faster you become debt-free with extra repayment.',
  'pkn.sce.debt.storyNoExtra': 'Without extra repayment, the debt follows today\'s repayment plan.',
  'pkn.sce.debt.story': 'If you pay {extra} extra on the debt every month, you become debt-free around {years} years earlier and save roughly {interest} in interest.',
  'pkn.sce.preset.child.name': 'Child',
  'pkn.sce.preset.child.note': 'Equipment, nursery and higher expenses',
  'pkn.sce.preset.wedding.name': 'Wedding',
  'pkn.sce.preset.wedding.note': 'One-off cost for the celebration',
  'pkn.sce.preset.leave.name': 'Longer leave',
  'pkn.sce.preset.leave.note': 'Reduced income for a period',
  'pkn.sce.preset.sabbatical.name': 'Sabbatical year',
  'pkn.sce.preset.sabbatical.note': 'One year without salary income',
  'pkn.sce.preset.partTime.name': 'Reduce working hours',
  'pkn.sce.preset.partTime.note': 'Permanently lower income',
  'pkn.sce.preset.raise.name': 'Pay rise',
  'pkn.sce.preset.raise.note': 'More to save every month',
  'pkn.sce.preset.renovation.name': 'Renovation',
  'pkn.sce.preset.renovation.note': 'Larger one-off cost on the home',
  'pkn.sce.preset.inheritance.name': 'Inheritance or bonus',
  'pkn.sce.preset.inheritance.note': 'One-off amount received (negative cost)',
  'pkn.sce.planInfo': 'This is the starting point all scenarios are calculated from. If you change the plan, the forecast, goals and retirement picture are updated automatically and saved for the selected year.',
  'pkn.sce.hintMonthlySave': 'A fixed amount you set aside every month',
  'pkn.sce.hintExtraDebt': 'On top of ordinary repayments — also builds net wealth',
  'pkn.sce.hintTarget': 'The target we measure the forecast against',
  'pkn.sce.hintReturn': 'A sober long-term average — 3–4 % is common',
  'pkn.sce.phAge': 'Your age',
  'pkn.sce.phDesiredAge': 'Desired age',
  'pkn.sce.pensionSpend': 'Expected monthly spending as a pensioner',
  'pkn.sce.pensionSpendHint': 'Only used in the retirement forecast.',
  'pkn.sce.newEvent': 'New life event',
  'pkn.sce.editEvent': 'Edit life event',
  'pkn.sce.add': 'Add',
  'pkn.sce.saveChanges': 'Save changes',
  'pkn.sce.hintOneOff': 'Negative number = one-off income',
  'pkn.sce.hintMonthlyEffect': 'Negative = higher expense / lower income',
  'pkn.sce.hintDuration': '0 = permanent change',
  'pkn.sce.newGoalDefault': 'New goal',
  'pkn.sce.leverFixed': 'Fixed monthly saving',
  'pkn.sce.leverSetUp': 'Set up fixed saving',
  'pkn.sce.goalPasses': '{name} passes {amount}',
  'pkn.sce.newGoal': 'New goal',
  'pkn.sce.editGoal': 'Edit goal',
  'pkn.sce.createGoal': 'Create goal',
  'pkn.sce.linkSavings': 'Link to savings account',
  'pkn.sce.linkSavingsHint': 'When an account is linked, the saved amount is fetched automatically from the latest registered balance.',
  'pkn.sce.noAccount': 'No account',
  'pkn.main.tab.idag': 'Today',
  'pkn.main.tab.oversikt': 'Overview',
  'pkn.main.tab.forbruk': 'Spending',
  'pkn.main.tab.familie': 'Family',
  'pkn.main.tab.fremtid': 'Future',
  'pkn.main.tab.reports': 'Reports',
  'pkn.main.tab.assets': 'Assets',
  'pkn.main.tab.gjeld': 'Debt',
  'pkn.main.tab.skatt': 'Tax',
  'pkn.main.tab.import': 'Import',
  'pkn.main.tab.transaksjoner': 'Transactions',
  'pkn.main.asset': 'Asset',
  'pkn.main.debt': 'Debt',
  'pkn.main.netWealth': 'Net wealth',
  'pkn.main.in': 'In',
  'pkn.main.out': 'Out',
  'pkn.main.loanPayments': 'Loan payments',
  'pkn.main.savingsInvesting': 'Saving/investing',
  'pkn.main.heroIntro': 'SuperPlumma helps you and your family with saving, budgeting, loans, pensions and the tax return — like a private financial adviser available around the clock.',
  'pkn.main.loadFailed': 'Could not fetch personal finance.',
  'pkn.main.actionUnavailable': 'The action is not available yet.',
  'pkn.main.actionFailed': 'The action failed.',
  'pkn.main.taskUpdated': 'The task has been updated.',
  'pkn.main.choiceSaved': 'The choice has been saved and will be used in later suggestions.',
  'pkn.main.moveUnavailable': 'Moving categories is not available yet.',
  'pkn.main.movedRuleSaved': 'Transactions moved and rule saved.',
  'pkn.main.moved': 'Transactions moved.',
  'pkn.main.moveFailed': 'Could not move the transactions.',
  'pkn.main.importUnavailable': 'Personal finance import is not available yet.',
  'pkn.main.uploadedShowingYear': 'The account statement has been uploaded. Showing {year}.',
  'pkn.main.uploaded': 'The account statement has been uploaded.',
  'pkn.main.uploadFailed': 'Upload failed.',
  'pkn.main.recatUnavailable': 'Re-categorising is not available yet.',
  'pkn.main.recatAlreadyRight': '{count} were already correct',
  'pkn.main.recatManual': '{count} were moved manually and were left untouched',
  'pkn.main.recatStillOther': '{count} are still in "Other"',
  'pkn.main.recatDone': '{done} of {total} transactions got a new category',
  'pkn.main.recatFailed': 'Re-categorising failed.',
  'pkn.main.bufferSaved': 'The buffer target has been saved.',
  'pkn.main.budgetSaved': 'The budget has been saved.',
  'pkn.main.householdSaved': 'The household has been saved.',
  'pkn.main.planSaved': 'The plan has been saved.',
  'pkn.main.assetSaved': 'Asset saved.',
  'pkn.main.assetDeleted': 'Asset deleted.',
  'pkn.main.loanSaved': 'The loan has been saved.',
  'pkn.main.loanDeleted': 'The loan has been deleted.',
  'pkn.main.taxChecklistSaved': 'The tax checklist has been saved.',
  'pkn.main.accountSaved': 'Account saved.',
  'pkn.main.accountDeleted': 'Account deleted together with its account statements.',
  'pkn.main.statementLinked': 'The account statement has been linked to an account.',
  'pkn.main.statementDeleted': 'The account statement has been deleted.',
  'pkn.main.assistantUnavailable': 'The personal finance assistant is not available.',
  'pkn.main.personalFinanceName': 'Personal finance',
  'pkn.fut.noEvents': 'No life events entered yet. Add one — for example a child, buying a home or a sabbatical year — and I will show how it affects your wealth and goals over time.',
});
